import { useMemo, useEffect } from "react"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { CONTENT_SET_DATA_TYPES } from "helpers/contentSetConstants"
import { CONTENT_SET_METADATA } from "resources/content-sets"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { useAssetViewTemplateChart } from "../../hooks/use-asset-view-template-chart"
import { ASSET_VIEW_CONTENT_SET_CHART } from "../template-chart-config"

export default function ContentSetHeader({ selectedContentSetMetadata }) {
  const { selectedCategory, setSelectedCategory, selectedMetricDisplay, setSelectedMetricDisplay } = useAssetViewTemplateChart(ASSET_VIEW_CONTENT_SET_CHART)
  const isSensitivity = selectedContentSetMetadata.dataType === CONTENT_SET_DATA_TYPES.SENSITIVITY

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const categoryOptions = useMemo(() => {
    if (!selectedContentSetMetadata?.categories) {
      return []
    }
    return selectedContentSetMetadata.categories.map(({ id, name }) => ({ id: id.toLowerCase(), primaryText: name }))
  }, [selectedContentSetMetadata])

  const displayOptions = useMemo(() => {
    const metricOptionsType = isSensitivity ? "sensitivityContentSet" : "contentSet"
    return METRIC_OPTIONS[metricOptionsType].map(({ label, secondaryText, ...props }) => ({
      primaryText: label,
      secondaryText: typeof secondaryText === "function" ? secondaryText({ isContentSet: true }) : secondaryText,
      ...props,
    }))
  }, [isSensitivity])

  useEffect(() => {
    if (!displayOptions) {
      return
    }

    const isSelectedMetricValid = displayOptions.some(({ id, disabled }) => !disabled && id === selectedMetricDisplay)

    if (!isSelectedMetricValid) {
      const defaultMetricDisplay = displayOptions.find(({ isDefault }) => isDefault)?.id || displayOptions[0].id
      setSelectedMetricDisplay(defaultMetricDisplay)
    }
  }, [isSensitivity, selectedMetricDisplay, displayOptions, setSelectedMetricDisplay])

  useEffect(() => {
    if (!categoryOptions.some(option => option.id === selectedCategory)) {
      setSelectedCategory(categoryOptions[0].id)
    }
  }, [categoryOptions, selectedCategory, setSelectedCategory])

  return <>
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={categoryOptions}
      alignMenu="left"
      disablePortal
    />
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

ContentSetHeader.propTypes = {
  selectedContentSetMetadata: CONTENT_SET_METADATA.isRequired,
}
